export function normalizeUrl(path) {
    if (!path) return null;

    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }

    const base = process.env.VUE_APP_ROOT_API.replace(/\/$/, '');

    return `${base}/${path.replace(/^\//, '')}`;
}
